import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
    selector: 'app-multischema',
    templateUrl: './multischema.component.html',
    styleUrls: ['./multischema.component.scss'],
    standalone: false
})
export class MultischemaComponent extends FieldType {}
